/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuoteTestGroupMetadata
 */
export interface QuoteTestGroupMetadata {
  /**
   *
   * @type {boolean}
   * @memberof QuoteTestGroupMetadata
   */
  isPermutationGroup?: boolean | null;
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestGroupMetadata
   */
  linearIds: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof QuoteTestGroupMetadata
   */
  shipmentIds: Array<string>;
}

/**
 * Check if a given object implements the QuoteTestGroupMetadata interface.
 */
export function instanceOfQuoteTestGroupMetadata(
  value: object,
): value is QuoteTestGroupMetadata {
  if (!("linearIds" in value) || value["linearIds"] === undefined) return false;
  if (!("shipmentIds" in value) || value["shipmentIds"] === undefined)
    return false;
  return true;
}

export function QuoteTestGroupMetadataFromJSON(
  json: any,
): QuoteTestGroupMetadata {
  return QuoteTestGroupMetadataFromJSONTyped(json, false);
}

export function QuoteTestGroupMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestGroupMetadata {
  if (json == null) {
    return json;
  }
  return {
    isPermutationGroup:
      json["isPermutationGroup"] == null
        ? undefined
        : json["isPermutationGroup"],
    linearIds: json["linearIds"],
    shipmentIds: json["shipmentIds"],
  };
}

export function QuoteTestGroupMetadataToJSON(
  json: any,
): QuoteTestGroupMetadata {
  return QuoteTestGroupMetadataToJSONTyped(json, false);
}

export function QuoteTestGroupMetadataToJSONTyped(
  value?: QuoteTestGroupMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    isPermutationGroup: value["isPermutationGroup"],
    linearIds: value["linearIds"],
    shipmentIds: value["shipmentIds"],
  };
}
